/*! @azure/msal-browser v4.20.0 2025-08-12 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "4.20.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
